import groq from 'groq'
import pageFields from '../fields/page'
import productFields from '../fields/product'
import imageField from '../fields/image'

export default (slug, id) => {
  let query
  if (id) {
    query = `_id == "${id}"`
  } else {
    query = `_type == "buyNow" && slug.current == "${slug}"`
  }
  return groq`
    *[${query}][0]{
      ...${pageFields},
      description,
      discountExplainer,
      defined(floatingImage) => {
        floatingImage{
          ...${imageField}
        }
      },
      defined(floatingImageBottomRight) => {
        floatingImageBottomRight{
          ...${imageField}
        }
      },
      defined(floatingImageBottomLeft) => {
        floatingImageBottomLeft{
          ...${imageField}
        }
      },
      cta,
      whyItsGreatTitle,
      whyItsGreat[]{
        thumbnail{
          ...${imageField}
        },
        heading1,
        heading2
      },
      frequency,
      marquees,
      products[]{
        title,
        subtitle,
        product->{
          ...${pageFields},
          ...${productFields}
        },
        variant{
          id
        }
      },
      faq{
        title,
        faqs[]{
          question,
          answer
        }
      }
    }
  `
}
